import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncGet, getDownload } from '@/api/async-util'

const types = {
    GET_WEBINAR_DOWNLOADS: createAsyncMutation('GET_WEBINAR_DOWNLOADS'),
    GET_WEBINAR_SESSIONS: createAsyncMutation('GET_WEBINAR_SESSIONS'),
    GET_HAS_MEMBER_EXCLUSIVE: createAsyncMutation('GET_HAS_MEMBER_EXCLUSIVE'),
}

const webinar = {
    state: {},
    mutations: {},
    actions: {
        // GET
        getHasMemberExclusive(store, userId) {
            let url = api.webinar + 'MemberExclusive?userId=' + userId
            return doAsyncGet(store, { url, mutationTypes: types.GET_HAS_MEMBER_EXCLUSIVE })
        },

        getWebinarDownloads(store) {
            let url = api.webinar + 'Downloads'
            return doAsyncGet(store, { url, mutationTypes: types.GET_WEBINAR_DOWNLOADS })
        },
        getWebinarSessions(store) {
            let url = api.webinar + 'Sessions'
            return doAsyncGet(store, { url, mutationTypes: types.GET_WEBINAR_SESSIONS })
        },

        // POST

        // PUT

        // DELETE
    },
    getters: {},
    types: types
}

export default webinar
